(function(){
    angular.module("tmx-app").directive('tmxAddress',[addressPartial]);

    function addressPartial(){
        var directive={
            scope:{
                model:"=",
                form:"=",
                readonly:"=",
                disabled:"="
            },
            templateUrl:"common/directives/address/address.html",
            controller:["$scope","AddressGeographyService",addressCtrl],
            controllerAs:"addressCtrl"
        };
        return directive;
    }

    function addressCtrl($scope,AddressGeographyService){
        var vm=this;
        vm.scope=$scope;
        vm.lookups={};
        if(!angular.isDefined($scope.readonly)){
            vm.scope.readonly = false;
        }
        if(!angular.isDefined($scope.disabled)){
            vm.scope.disabled = false;
        }
		
		//vm.scope.model.AddressGeographyId = vm.scope.model.City;
		
		// vm.scope.model.AddressGeographyId = vm.scope.model.City;
		// if(angular.isDefined(vm.scope.model) && (vm.scope.model!=null) && angular.isDefined(vm.scope.model.AddressGeographyId) && vm.scope.model.AddressGeographyId!=null)
		// {
		// 	AddressGeographyService.getParentById(vm.scope.model.AddressGeographyId).then(
		// 		function(parents){
		// 			if(angular.isDefined(parents))
		// 			{	
		// 				vm.scope.model.TmXAddressGeography = {};
		// 				vm.scope.model.TmXAddressGeography.TmxAddressGeography2 = {};
		// 				// vm.scope.model2.TmXAddressGeography=vm.scope.model.TmXAddressGeography;
		// 				vm.scope.model.TmXAddressGeography.TmxAddressGeography2.ParentGeographyId = parents.data.CountryId;
		// 				vm.scope.model.TmXAddressGeography.ParentGeographyId = parents.data.ProvinceId;
		// 			}
		// 		});
		// }

		// if(angular.isDefined(vm.scope.model) && (vm.scope.model!=null) && angular.isDefined(vm.scope.model.City) && vm.scope.model.City!=null)
		// {
		// 	AddressGeographyService.getParentById(vm.scope.model.City).then(
		// 		function(parents){
		// 			if(angular.isDefined(parents))
		// 			{	
		// 				vm.scope.model.Country = parents.data.CountryId;
		// 				vm.scope.model.Province = parents.data.ProvinceId;
						
		// 			}
		// 		});
		// }
		// else
		// {
		// 	 
		// }

        AddressGeographyService.getCountries().then(
            function(countries){
                decorateForSelect(countries);
                vm.countries=countries;
            }
        );

		//vm.countryId = vm.scope.model.TmXAddressGeography.TmxAddressGeography2.ParentGeographyId
        vm.updateStates=function(countryId){
            if(!angular.isDefined(countryId) || countryId===null) {
                vm.states=[];
                vm.scope.model.Province = null;
                if(angular.isDefined(vm.scope.model))
                    if(angular.isDefined(vm.scope.model.TmXAddressGeography)) {
                        vm.scope.model.AddressGeographyId=null;
                        if(vm.scope.model.TmXAddressGeography)
                            vm.scope.model.TmXAddressGeography.ParentGeographyId=null;
                    }return;
            }

            AddressGeographyService.getStatesByCountryId(countryId).then(
                function(states){
                    decorateForSelect(states);
                    vm.states=states;
                }
            );
        }

        vm.updateCities=function(stateId){
            if((!(angular.isDefined(stateId)) || stateId===null) && angular.isDefined(vm.scope.model)) {
                vm.cities=[];
                vm.scope.model.City = null;
				// vm.scope.model.TmXAddressGeography=null;
                vm.scope.model.AddressGeographyId=null;
                return;
            }

			// vm.scope.model.AddressGeographyId=null;
            AddressGeographyService.getCitiesByStateId(stateId).then(
                function(cities){
                    decorateForSelect(cities.data);
                    vm.cities=cities.data;
                }
            );
        }
		
        if(vm.scope.model && vm.scope.model.Country) {
            vm.updateStates(vm.scope.model.Country);
        }

        if(vm.scope.model && vm.scope.model.Province) {
            vm.updateCities(vm.scope.model.Province);
        }

        vm.selectedCity=function(stateId){
        }
    }

    function decorateForSelect(arrayOfObj){
        arrayOfObj.forEach(
            function(obj){
                obj.VisibleValue=obj.GeographyName;
                obj.HiddenValue=obj.AddressGeographyId;
            }
        );
    }

})();